import React from "react";
import { withTranslation } from "react-i18next";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import styles from "./Modals.module.scss";
import crossIcon from "assets/images/cross.svg";
import staffStyles from "pages/Staff/staff.module.scss";

function AboutSchedulerModal({
  t,
  showSwitchOwnerModal,
  setShowSwitchOwnerModal,
}) {
  return (
    <Modal
      isOpen={showSwitchOwnerModal}
      toggle={() => setShowSwitchOwnerModal(false)}
      className={
        "modal-dialog-centered modal-width-660 " +
        styles["change-schedule-modal-dialog"]
      }
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => setShowSwitchOwnerModal(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={staffStyles.modal_container}>
          <h5 className={staffStyles.title_style}>
            {t("scheduler.aboutModalHeading")}
          </h5>
          <p>{t("scheduler.aboutModalIntro")}</p>
          <ul className={styles.bulletSection}>
            <li className={styles.list_marker}>
              <span className={staffStyles.title_style}>
                {t("scheduler.officeSchedule")}
              </span>
              <ul className={styles.subBullet}>
                <li>
                  <p>
                    <strong>{t("scheduler.staffSchedule")}:</strong>{" "}
                    {t("scheduler.staffScheduleText")}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{t("scheduler.eventWorkspace")}:</strong>{" "}
                    {t("scheduler.eventWorkspaceText")}
                  </p>
                </li>
              </ul>
            </li>

            <li className={styles.list_marker}>
              <span className={staffStyles.title_style}>
                {t("scheduler.mySchedule")}
              </span>
              <ul className={styles.subBullet}>
                <li>
                  <p>
                    <strong>{t("scheduler.myEvents")}:</strong>{" "}
                    {t("scheduler.myEventsText")}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{t("scheduler.invitationRequests")}:</strong>{" "}
                    {t("scheduler.invitationRequestsText")}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{t("scheduler.otherOfficeEvents")}:</strong>{" "}
                    {t("scheduler.otherOfficeEventsText")}
                  </p>
                </li>
              </ul>
            </li>
            <li className={styles.list_marker}>
              <span className={staffStyles.title_style}>
                {t("scheduler.filterEvents")}
              </span>
              <p>{t("scheduler.filterEventsDescription")}</p>
              <ul className={styles.subBullet}>
                <li>
                  <p>
                    <strong>{t("scheduler.filterEventsFirstBullet")}</strong>
                    {t("scheduler.filterEventsFirstBulletDescription")}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{t("scheduler.filterEventsSecondBullet")}</strong>
                    {t("scheduler.filterEventsSecondBulletDescription")}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{t("scheduler.filterEventsThirdBullet")}</strong>
                    {t("scheduler.filterEventsThirdBulletDescription")}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{t("scheduler.filterEventsFourthBullet")}</strong>
                    {t("scheduler.filterEventsFourthBulletDescription")}
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AboutSchedulerModal);
